import { createFileRoute } from "@tanstack/react-router";
import { EditorialPolicyPage } from "@/pages/trust/TrustPages";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/editorial-policy")({
  head: () =>
    seoHead({
      title: "Editorial Policy",
      description: "How LeadXkids chooses topics, uses evidence, reviews content, cites sources, updates articles and uses AI tools in drafting.",
      canonical: "/editorial-policy",
      pageType: "WebPage",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Home", url: "/" },
          { name: "Editorial policy", url: "/editorial-policy" },
        ]),
      ],
    }),
  component: EditorialPolicyPage,
});
